import {useLocation, useNavigate, useParams} from 'react-router-dom';
import EmptyImage from '../../../../../assets/image/shared/chat_empty_profile_image.svg';
import useGetRecieverData from '../../../../../services/hookService/chats/getRecieverData/useGetRecieverData';
import useGetUserChatDetail from '../../../../../services/hookService/chats/getUserCHatDetail/useGetUserCHatDetail';

interface HeaderInfoProps {
  supplierGuid: string;
  name?: string;
  imgUrl?: string;
  prevRoute?: () => void;
}
const HeaderInfo = ({
  prevRoute,
  supplierGuid,
  name,
  imgUrl,
}: HeaderInfoProps) => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const {guid: roomGuid} = useParams();

  const {userChatDetailData, userChatDetailIsLoading} =
    useGetUserChatDetail(roomGuid);
  const {data, isLoading} = useGetRecieverData({
    supplierGuid: supplierGuid || state?.supplierGuid,
  });

  const handleNavigation = () => {
    const {store_guid, lab_guid} = userChatDetailData?.receiver_profile ?? {};

    if (!store_guid && !lab_guid) return;

    navigate(
      store_guid
        ? `/shop-card-detail/${store_guid}`
        : `/lab-card-detail/${lab_guid}`,
    );
  };

  return (
    <>
      {isLoading || userChatDetailIsLoading ? (
        // Skeleton
        <div className="flex items-center w-full h-full gap-2">
          <div className="flex items-center">
            <div className="w-[19px] h-[19px] bg-gray-300 rounded-full animate-pulse" />
          </div>
          <div className="flex items-center w-full gap-2">
            <div className="flex w-[38px] h-[38px]">
              <div className="w-[38px] h-[38px] rounded-full bg-gray-300 animate-pulse" />
            </div>
            <div className="flex flex-col">
              <div className="w-24 h-[14px] rounded bg-gray-300 animate-pulse" />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center h-full font-normal">
            <button
              onClick={() => {
                prevRoute ? prevRoute() : navigate(-1);
              }}
              className="icon-nameArrow---Right text-[19px] text-gray-700"
            />
          </div>
          <div
            className="flex items-center w-full gap-2"
            onClick={handleNavigation}
          >
            <div className="flex w-[38px] h-[38px]">
              <img
                className="rounded-full"
                src={
                  userChatDetailData?.receiver_profile?.profile_image ||
                  data?.profile_image ||
                  EmptyImage
                }
                width={38}
                height={38}
                alt="profile"
                loading="lazy"
              />
            </div>
            <div className="">
              <span className="font-normal text-[14px] leading-[24px]">
                {data?.name || name}
              </span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderInfo;
